import * as React from 'react';
import { MouseEvent } from 'react';
import './AcceptAgreement.scss';
import {
  IProductInfo,
  IState,
  IUserInfo,
  IReferer,
  ISessionInfo,
  Push
} from '../CustomTypes';
import { connect } from 'react-redux';
import { svgLoggedIn } from '../icons';
import {
  toTitleCase,
  doSpidLoginLinkWithRedirectToStart,
  getRedirectUrlInLocalStorage,
  createStartPageFullUrl
} from '../fastflowUtils';
import Button from '../input-components/Button';
import { getIdentity } from '../actions/Actions';
import { ClientShortHandName } from '@snoam/mono-scc';
import { FooterSameLoginAsOthers } from '../layout-components/FooterSameLoginAsOthers';
import { bindActionCreators } from '../../node_modules/redux';
import { push } from 'redux-router';
import { sccPulseTrackPageView } from '../PulseUtils';

interface IStateProps {
  productId: string;
  productInfo: IProductInfo;
  userInfo: IUserInfo;
  sessionInfo: ISessionInfo;
  referer: IReferer;
}

interface IDispatchProps {
  push: Push;
}

export interface IAcceptAgreemntProps extends IStateProps, IDispatchProps {}

export class AcceptAgreement extends React.Component<
  IAcceptAgreemntProps,
  IDispatchProps
> {
  constructor(props: IAcceptAgreemntProps) {
    super(props);
    this.logout = this.logout.bind(this);
    this.acceptAgreement = this.acceptAgreement.bind(this);
  }

  public render() {
    const { userInfo, productInfo } = this.props;
    return (
      <div className="acceptagreement">
        <div className="container">
          <h1 className="icon">{svgLoggedIn()}</h1>
          <h1>Hei, {toTitleCase(userInfo.firstName)}</h1>
          <p>
            Du er automatisk logget inn hos {productInfo.owningClientName}
            {userInfo.email ? `med ${userInfo.email}` : null}
          </p>
          <Button onClick={this.acceptAgreement}>Oppdater din profil</Button>
          <p>
            Ikke riktig bruker?{' '}
            <span onClick={this.logout} className={'logout-link'}>
              Klikk for å logge ut
            </span>
          </p>
        </div>
        <FooterSameLoginAsOthers productInfo={productInfo} />
      </div>
    );
  }

  public componentDidMount() {
    if (
      this.props.userInfo.acceptedAgreement !== undefined &&
      !this.props.userInfo.acceptedAgreement
    ) {
      sccPulseTrackPageView(
        this.props.productInfo,
        {},
        'Viewed update your profile'
      );
    } else {
      this.props.push(
        `/products/${
          this.props.productId
        }/start?${getRedirectUrlInLocalStorage()}`
      );
    }
  }

  private async acceptAgreement(e: MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    const { owningClient, productId, spidTeaser } = this.props.productInfo;
    doSpidLoginLinkWithRedirectToStart(
      owningClient,
      productId,
      this.props.userInfo.email,
      spidTeaser
    );
  }

  private logout() {
    const { owningClient, productId } = this.props.productInfo;
    const startPageFullUrl = createStartPageFullUrl(productId);
    getIdentity(owningClient as ClientShortHandName).logout(startPageFullUrl);
  }
}

export default connect<IStateProps, IDispatchProps, {}>(
  (s: IState) => ({
    productId: s.router.params.productId,
    productInfo: s.productInfo,
    referer: s.referer,
    sessionInfo: s.sessionInfo,
    userInfo: s.userInfo
  }),
  dispatch =>
    bindActionCreators(
      {
        push
      },
      dispatch
    )
)(AcceptAgreement);



// WEBPACK FOOTER //
// ./src/page-components/AcceptAgreement.tsx